import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

export default function Field({ value, list, onChange }) {
    const fieldOption = list.map(i => <Option key={i.responsibleFieldId}>{i.responsibleFieldName}</Option>);
    return (
        <Select
            value={value}
            placeholder="请选择"
            style={{ width: 160 }}
            onChange={(value) => onChange(value, 'responsibleFieldId')}
        >
            {fieldOption}
        </Select>
    );
};



// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/Field.js